export default "__VITE_ASSET__8192cb18__"